/**
 * @constructor
 * @returns {undefined}
 */
import {ReelMotion} from "./ReelMotion";
import {SpinReel} from "./SpinReel";
import {ReelPrinter} from "./ReelPrinter";
import {copyArray} from "../../framework/src/helpers";
import {arrayCircleGetIndex} from "../utils/helpers";

export default function ReelManager()
{
    /** {GameConfig} */
    this._gConfig;

    /** {ServerConfig} */
    this._serverConfig;

    /** @type {SymbolsManager} */
    this._symbManager;

    /** @type {ReelMotion} */
    this._motion;

    /** @type {ReelPrinter} */
    this._printer;

    /** @type {SpinReel} */
    this._reel;
}

/**
 * @param {GameConfig} gameConfig
 * @param {ServerConfig} serverConfig
 * @param {SymbolsManager} symbolsManager
 * @param {GameGroups} groups
 */
ReelManager.prototype.init = function(gameConfig, serverConfig, symbolsManager, groups) {
    this._gConfig = gameConfig;
    this._serverConfig = serverConfig;
    this._symbManager = symbolsManager;
    this._groups = groups;
};

/** @returns {SpinReel} */
ReelManager.prototype.getReel = function() {
    return this._reel;
};

/** @returns {ReelMotion} */
ReelManager.prototype.getMotion = function() {
    return this._motion;
};

ReelManager.prototype.create = function(id) {

    var group = this._groups.get("group_symbols_" + id);

    this._reel = new SpinReel();
    this._motion = new ReelMotion();
    this._printer = new ReelPrinter(this._gConfig);

    this._reel.init(id, this._gConfig, this._symbManager);

    var serverReels = this._serverConfig.getReels();
    var serverMatrix = this._serverConfig.getReelMatrix();
    var failMatrix = this._serverConfig.getFailResult();
    var serverPositions = this._serverConfig.getPositions();


    this._reel.setAllMatrix(copyArray(serverReels[id]));
    this._reel.setReelMatrix(copyArray(serverMatrix[id]));
    this._reel.setFailMatrix(copyArray(failMatrix[id]));
    this._reel.setSymbolPosition(serverPositions[id]);

    this._createSpinSymbols(group);
    var resSymbols = this.initResSymbols(group);

    for(var i = 0; i < resSymbols.length; i++) {
        resSymbols[i].createSymbol();
    }

    this._initSymbols(resSymbols);

    this._motion.init(this._gConfig, this._serverConfig, this._reel, this._printer);
};

ReelManager.prototype.print = function() {
    this._printer.print(this._reel);
};

ReelManager.prototype.reinitSpeed = function() {
    this._motion.reinitSpeed();
};

ReelManager.prototype.reinitPositions = function() {
    var symbols = this._reel.getSpinSymbols();

    for(var i = 0; i < symbols.length; i++) {
        symbols[i].setPosY(-9999);
    }
};

ReelManager.prototype.killSpinSymbols = function() {
    var symbols = this._reel.getSpinSymbols();

    for(var i = 0; i < symbols.length; i++) {
        symbols[i].kill();
    }
};

ReelManager.prototype.reviveSpinSymbols = function() {
    var symbols = this._reel.getSpinSymbols();

    for(var i = 0; i < symbols.length; i++) {
        symbols[i].revive();
        symbols[i].setVisible(true);
    }
};

ReelManager.prototype.prepareSymbolsForSpin = function() {

    var symbols = this._reel.getSymbols();

    for(var i = 0; i < symbols.length; i++) {
        symbols[i].revive();
        symbols[i].setVisible(true);
    }
};

ReelManager.prototype.symbolsOversetResToTmp = function() {
    this._setTmpSymbols();
    this._initTmpSymbols();
    this._clarResSymbols();
};

/** @param {Array<MadnesObject>} _symbols */
ReelManager.prototype._initSymbols = function(_symbols) {

    var resSymbols = this._reel.getResSymbols();
    var spinSymbols = this._reel.getSpinSymbols();
    var symbols = this._reel.getSymbols();

    var allMatrix = this._reel.getAllMatrix();

    if(spinSymbols.length > 0) {
        symbols[0] = spinSymbols[arrayCircleGetIndex(allMatrix, this._reel.symbolPosition)];
        symbols[0].setVisible(false);

        symbols[resSymbols.length + 1] = spinSymbols[arrayCircleGetIndex(allMatrix, this._reel.symbolPosition - 1)];
        symbols[resSymbols.length + 1].setVisible(false);
    }

    for(var j = 0; j < _symbols.length; j++) {
        symbols[j + 1] = _symbols[j];
    }
};

/**
 * Creates reels blurred symbols (not win symbols)
 * @param {MadnesGroup} group
 */
ReelManager.prototype._createSpinSymbols = function(group) {
    var i = this._reel.id;
    var x = this._gConfig.reelsPositions[i]["x"];

    var allMatrix = this._reel.getAllMatrix();
    var spinSymbols = this._reel.getSpinSymbols();

    for(var j = 0; j < allMatrix.length; j++) {

        var symbol = this._symbManager.create(allMatrix[j], x, -9999, i, j);
        symbol.setVisible(false);
        symbol.createBlurSymbol();

        group.add(symbol);

        spinSymbols[j] = symbol;
    }
};

/**
 * Initializes reel symbols after result load
 * @param {MadnesGroup} group
 * @returns {Array<MadnesObject>}
 */
ReelManager.prototype.initResSymbols = function(group) {
    var i = this._reel.id;
    var x = this._gConfig.reelsPositions[i]["x"];

    var reelMatrix = this._reel.getReelMatrix();
    var resSymbols = this._reel.getResSymbols();

    resSymbols.length = 0;

    for(var j = 0; j < reelMatrix.length; j++) {

        resSymbols[j] = this._symbManager.create(reelMatrix[j], x, -9999, i, j);
        //console.log(resSymbols[j].$debug());


        group && group.add(resSymbols[j]);
    }

    return resSymbols;
};

ReelManager.prototype._setTmpSymbols = function() {

    var symbols = this._reel.getResSymbols();
    var tmpSymbols = this._reel.getTmpSymbols();

    for(var i = 0; i < symbols.length; i++) {
        tmpSymbols.push(symbols[i]);
    }
};

ReelManager.prototype._initTmpSymbols = function() {
    this._initSymbols(this._reel.getTmpSymbols());
};

ReelManager.prototype._clarResSymbols = function() {
    this._reel.getResSymbols().length = 0;
};

ReelManager.prototype.start = function() {
    this._reel.started = true;
    return this._motion.start();
};

ReelManager.prototype.stop = function() {
    this._reel.started = false;
    return this._motion.stop();
};


ReelManager.prototype.hasStarted = function() {
    return this._reel.started;
};

ReelManager.prototype.onSpin = function(func) {
    this._motion.onSpin(func);
};

ReelManager.prototype.onStop = function(func) {
    this._motion.onStop(func);
};

ReelManager.prototype.onBrakeDown = function(func) {
    this._motion.onBrakeDown(func);
};

ReelManager.prototype.onBrakeUp = function(func) {
    this._motion.onBrakeUp(func);
};

ReelManager.prototype.addSymbolsToStop = function(count) {
    this._motion.addSymbolsToStop(count);
};

ReelManager.prototype.setResultSymbols = function() {
    this._motion.setResultSymbols(this._reel.getResSymbols());
};


ReelManager.prototype.removeTmpSymbols = function() {
    var symbols = this._reel.getTmpSymbols();

    for(var i = 0; i < symbols.length; i++) {
        symbols[i].destroy();
    }
    symbols.length = 0;
};

ReelManager.prototype.unblurResSymbols = function() {
    this._symbManager.unblurSymbols(this._reel.getResSymbols());
};

ReelManager.prototype.blurTmpSymbols = function() {
    this._symbManager.blurSymbols(this._reel.getTmpSymbols());
};

ReelManager.prototype.showReel = function() {
    this._groups.get("group_symbols_" + this._reel.id).setVisible(true);
    this._groups.get("group_symbols_anims_" + this._reel.id).setVisible(true);
};

ReelManager.prototype.hideReel = function() {
    this._groups.get("group_symbols_" + this._reel.id).setVisible(false);
    this._groups.get("group_symbols_anims_" + this._reel.id).setVisible(false);
};

ReelManager.prototype.isReelHided = function() {
    return !this._groups.get("group_symbols_" + this._reel.id).getVisible();
};

ReelManager.prototype.transformResSymbols = function() {

    var reelMatrix = this._reel.getReelMatrix();
    var resSymbols = this._reel.getResSymbols();

    for(var i = 0; i < resSymbols.length; i++) {
        this._symbManager.transform(resSymbols[i], reelMatrix[i]);
    }
};

ReelManager.prototype.hasWild = function() {

    var resSymbols = this._reel.getResSymbols();

    for(var i = 0; i < resSymbols.length; i++) {

        if(resSymbols[i].symbolName === "symbol_Wild") {
            return true;
        }
    }

    return false;
};

ReelManager.prototype.hasBonus = function() {
    var resSymbols = this._reel.getResSymbols();

    for(var i = 0; i < resSymbols.length; i++) {

        if(resSymbols[i].symbolName === "symbol_Star") {
            return true;
        }
    }

    return false;
};